/**
 * Font family definitions per ProductContext.
 *
 * Figma "Font" variable collection defines 3 roles:
 *   - display: heading/display font (Pilat or Pilat Wide)
 *   - compact: body/UI font (Aktiv Grotesk or Montserrat)
 *   - text: paragraph/reading font (same families as compact)
 *
 * The `heading` and `body` exports map to these Figma roles:
 *   heading → display
 *   body → compact (also used for text contexts)
 */

import type { ProductContext } from "./typography";

const FALLBACK =
  '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif';

const displayFontByContext: Record<ProductContext, string> = {
  b2b: `"Pilat", "Aktiv Grotesk", "Noto Sans", "Montserrat", ${FALLBACK}`,
  b2c: `"Pilat Wide", "Aktiv Grotesk", "Noto Sans", "Montserrat", ${FALLBACK}`,
};

const bodyFont = `"Aktiv Grotesk", "Noto Sans", "Montserrat", ${FALLBACK}`;

/** Static fonts object (defaults to B2B for backwards compatibility) */
export const fonts = {
  heading: displayFontByContext.b2b,
  body: bodyFont,
  /** Paragraph/reading font — same families as body */
  text: bodyFont,
  /** @deprecated Use `heading` or `body` instead */
  primary: bodyFont,
};

/** Returns context-aware font families */
export const getFonts = (productContext: ProductContext = "b2b") => ({
  heading: displayFontByContext[productContext],
  body: bodyFont,
  /** Paragraph/reading font — same families as body */
  text: bodyFont,
  /** @deprecated Use `heading` or `body` instead */
  primary: bodyFont,
});

export const typography = {
  button: {
    fontFamily: fonts.body,
    fontWeight: "bold",
  },
};
